import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const HeaderCTAsBase = styled.div`
  display: none;

  ${theme.largerThan.md} {
    display: flex;
    gap: ${theme.spacing[2]};
    flex-shrink: 0;
  }
`;

export const StyledCTA = styled(CTA)`
  .outline-blue {
    display: none;
  }
`;
